import script from "./StockFormComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./StockFormComponent.vue?vue&type=script&setup=true&lang=js"

import "./StockFormComponent.vue?vue&type=style&index=0&id=e3474820&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3474820"]])

export default __exports__